import { render } from "./CMarket.vue?vue&type=template&id=4825ccb0"
import script from "./CMarket.vue?vue&type=script&lang=js"
export * from "./CMarket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__